import { createAction } from '@reduxjs/toolkit';

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<boolean>} */
export const setUserVerificationModalOpen = createAction(
    'USER_VERIFICATION_MODAL::SET_IS_MODAL_OPEN',
);

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<boolean>} */
export const setUserVerificationHelpModalOpen = createAction(
    'USER_VERIFICATION_HELP_MODAL::SET_IS_MODAL_OPEN',
);

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<boolean>} */
export const setUpdatePhoneModalOpen = createAction(
    'UPDATE_PHONE_MODAL::SET_IS_MODAL_OPEN',
);
